module.exports = __webpack_public_path__ + "static/media/documento-de-verificacao-min.37fcb023.png";